module.exports = __webpack_public_path__ + "img/sw-b02.6741a244.png";